import { useAuthStore, APP_MODE } from '@/stores/authStore';
import { Link, useNavigate } from 'react-router-dom';

export function DevBar() {
    const { role, toggleRole, clearTokens } = useAuthStore();
    const nav = useNavigate();
    if (!import.meta.env.DEV) return null;

    const port = window.location.port;
    const isReal = APP_MODE === 'real';

    const onLogout = () => {
        clearTokens();
        nav('/auth/login');
    };

    return (
        <div className="fixed top-2 right-2 z-[60] flex items-center gap-1 rounded-full bg-zinc-900/95 backdrop-blur border border-zinc-700 px-1.5 py-1 shadow-lg text-[10px]">
            <span
                className={`px-2 py-0.5 rounded-full font-bold uppercase ${
                    isReal ? 'bg-green-500/20 text-green-300' : 'bg-blue-500/20 text-blue-300'
                }`}
                title={`Modalità ${APP_MODE} · porta ${port}`}
            >
                {APP_MODE}:{port}
            </span>
            <button
                onClick={toggleRole}
                className="rounded-full bg-purple-500/20 text-purple-300 px-2 py-0.5 font-semibold uppercase"
            >
                {role}
            </button>
            <Link to="/" className="rounded-full bg-zinc-800 text-zinc-300 px-2 py-0.5 font-semibold">
                /
            </Link>
            <button
                onClick={onLogout}
                className="rounded-full bg-red-500/20 text-red-300 px-2 py-0.5 font-semibold uppercase"
                title="Logout per testare login reale"
            >
                out
            </button>
        </div>
    );
}
